import { defineMessages } from 'react-intl';

export const GenericMessages = defineMessages({
  loading: {
    id: 'Generic.loading',
    defaultMessage: 'Loading...',
    description: 'Used to indicate an user interface element is loading',
  },
  cancelButtonLabel: {
    id: 'Generic.cancelButtonLabel',
    defaultMessage: 'Cancel',
  },
  nextButtonLabel: {
    id: 'Generic.nextButtonLabel',
    defaultMessage: 'Next',
  },
  searchPlaceholder: {
    id: 'Generic.searchPlaceholder',
    defaultMessage: 'Search',
  },
  unknownPlaceholder: {
    id: 'Generic.unknownPlaceholder',
    defaultMessage: 'Unknown',
    description: 'Placeholder shown when another value cannot be resolved.',
  },
  closeButtonPlaceholder: {
    id: 'Generic.closeButtonPlaceholder',
    defaultMessage: 'Close',
  },
  saveButtonLabel: {
    id: 'Generic.saveButtonLabel',
    defaultMessage: 'Save',
  },
  printButtonLabel: {
    id: 'Generic.printButtonLabel',
    defaultMessage: 'Print',
  },
  yesButtonLabel: {
    id: 'Generic.yesButtonLabel',
    defaultMessage: 'Yes',
  },
  noButtonLabel: {
    id: 'Generic.no',
    defaultMessage: 'No',
  },
  okButtonLabel: {
    id: 'Generic.ok',
    defaultMessage: 'OK',
  },
  descriptionLabel: {
    id: 'Generic.description',
    defaultMessage: 'Description',
  },
  orgLabel: {
    id: 'Generic.org',
    defaultMessage: 'Org',
    description: 'Abbrevation for organization',
  },
  parsing: {
    id: 'Generic.parsing',
    defaultMessage: 'Parsing...',
    description: "Used to indicate a job log's data is being parsed.",
  },
  notAvailablePlaceholder: {
    id: 'Generic.notAvailablePlaceholder',
    defaultMessage: 'Not Available',
  },
  complete: {
    id: 'Generic.complete',
    defaultMessage: 'Complete',
  },
  uploadedBy: {
    id: 'Generic.uploadedBy',
    defaultMessage: 'Uploaded By',
  },
  profile: {
    id: 'Generic.profile',
    defaultMessage: 'Profile',
    description: 'A user profile',
  },
  signOut: {
    id: 'Generic.signOut',
    defaultMessage: 'Sign Out',
    description: 'Sign out of the application',
  },
  delete: {
    id: 'Generic.delete',
    defaultMessage: 'Delete',
    description: 'Delete something',
  },
  edit: {
    id: 'Generic.edit',
    defaultMessage: 'Edit',
    description: 'Edit something',
  },
  description: {
    id: 'Generic.description',
    defaultMessage: 'Description',
  },
  logOut: {
    id: 'Generic.logOut',
    defaultMessage: 'Log out',
  },
  stoneAge: {
    id: 'Generic.stoneAge',
    defaultMessage: 'StoneAge',
  },
  sentinelLink: {
    id: 'Generic.sentinelLink',
    defaultMessage: 'Sentinel Link',
  },
  externalLinks: {
    id: 'Generic.externalLinks',
    defaultMessage: 'External Links',
  },
  of: {
    id: 'Generic.of',
    defaultMessage: 'of',
  },
  dataTablesNextPage: {
    id: 'Generic.dataTablesNextPage',
    defaultMessage: 'Next Page',
  },
  dataTablesPreviousPage: {
    id: 'Generic.dataTablesPreviousPage',
    defaultMessage: 'Previous Page',
  },
  dataTablesRowsPerPage: {
    id: 'Generic.dataTablesRowsPerPage',
    defaultMessage: 'Rows Per Page',
  },
  dataTablesDisplayRows: {
    id: 'Generic.dataTablesDisplayRows',
    defaultMessage: 'Display Rows ',
  },
  dataTablesSort: {
    id: 'Generic.dataTablesSort',
    defaultMessage: 'Sort',
  },
  dataTablesViewColumns: {
    id: 'Generic.dataTablesViewColumns',
    defaultMessage: 'View Columns',
  },
  dataTablesFilterTable: {
    id: 'Generic.dataTablesFilterTable',
    defaultMessage: 'Filter Table',
  },
  dataTablesFilters: {
    id: 'Generic.dataTablesFilters',
    defaultMessage: 'FILTER',
  },
  dataTablesReset: {
    id: 'Generic.dataTablesReset',
    defaultMessage: 'RESET',
  },
  dataTablesAll: {
    id: 'Generic.dataTablesAll',
    defaultMessage: 'ALL',
  },
  dataTablesShowColumns: {
    id: 'Generic.dataTablesShowColumns',
    defaultMessage: 'Show Columns',
  },
  editedBy: {
    id: 'Generic.editedBy',
    defaultMessage: 'Edited by {userName}',
    description: 'String used to display who last edited a record',
  },
  headerBannerLimitedOffline: {
    id: 'Generic.headerBannerLimitedOffline',
    defaultMessage: 'You are currently offline. Your experience may be limited.',
  },
  headerBannerLimitedSessionExpired: {
    id: 'Generic.headerBannerLimitedSessionExpired',
    defaultMessage: 'Your session has expired. Your experience may be limited.',
  },
  headerBannerLimitedUnknown: {
    id: 'Generic.headerBannerLimitedUnknown',
    defaultMessage: 'Cannot communicate with the Sentinel system. Your experience may be limited.',
  },
  deleteWarning: {
    id: 'Generic.deleteWarning',
    defaultMessage: 'This action cannot be undone. The data will be removed from our system and cannot be recovered.',
    description: 'Warning message describing that delete actions in the system are permanent.',
  },
  submitButtonLabel: {
    id: 'Generic.submiteButtonLabel',
    defaultMessage: 'Submit',
  },
  fieldRequiredLabel: {
    id: 'Generic.fieldRequiredLabel',
    defaultMessage: 'This field is required',
  },
  requiredLabel: {
    id: 'Generic.requiredLabel',
    defaultMessage: 'Required',
  },
  idColumnLabel: {
    id: 'Generic.idColumnLabel',
    defaultMessage: 'Id',
  },
  emailColumnLabel: {
    id: 'Generic.emailColumnLabel',
    defaultMessage: 'Email',
  },
  emailAddressInvalidMessage: {
    id: 'Generic.emailAddressInvalidMessage',
    defaultMessage: 'Email address is invalid',
  },
  lastNameColumnLabel: {
    id: 'Generic.lastNameLabel',
    defaultMessage: 'Last Name',
  },
  lastNamePlaceholder: {
    id: 'Generic.lastNamePlaceholder',
    defaultMessage: 'Last',
  },
  firstNameColumnLabel: {
    id: 'Generic.firstNameLabel',
    defaultMessage: 'First Name',
  },
  firstNamePlaceholder: {
    id: 'Generic.firstNamePlaceholder',
    defaultMessage: 'First',
  },
  nameLabel: {
    id: 'Generic.nameLabel',
    defaultMessage: 'Name',
  },
  emailAddressLabel: {
    id: 'Generic.emailAddressLabel',
    defaultMessage: 'Email Address',
  },
  organizationColumnLabel: {
    id: 'Generic.organizationLabel',
    defaultMessage: 'Organization',
  },
  organizationPlaceholder: {
    id: 'Generic.organizationPlaceholder',
    defaultMessage: 'Guest Organization',
  },
  roleColumnLabel: {
    id: 'Generic.roleLabel',
    defaultMessage: 'Role',
  },
  statusLabel: {
    id: 'Generic.statusLabel',
    defaultMessage: 'Status',
  },
  tosLabel: {
    id: 'Generic.tosLabel',
    defaultMessage: 'TOS Accepted',
  },
  removeAndChooseFileLabel: {
    id: 'Generic.removeAndChooseFileLabel',
    defaultMessage: 'Remove and Choose a New File',
  },
  customerNumberLabel: {
    id: 'Generic.customerNumberLabel',
    defaultMessage: 'Customer #',
  },
  liveStreamLabel: {
    id: 'Generic.liveStreamLabel',
    defaultMessage: 'Live Stream',
    description: 'Describes a functionality that allows for log data to be streamed to the server.',
  },
  buildABundleLabel: {
    id: 'Generic.buildABundleLabel',
    defaultMessage: 'Build a Bundle',
    description:
      'Describes a functionality in the app that allows users to build a template of a heat exchanger bundle.',
  },
  invoiceNumberLabel: {
    id: 'Generic.invoiceNumberLabel',
    defaultMessage: 'Invoice #',
  },
  expiresLabel: {
    id: 'Generic.expiresLabel',
    defaultMessage: 'Expires',
  },
  expiredLabel: {
    id: 'Generic.expiredLabel',
    defaultMessage: 'Expired',
  },
  notApplicableLabel: {
    id: 'Generic.notApplicableLabel',
    defaultMessage: 'N/A',
    description: 'Abbreviation for not applicable',
  },
  contactSupportLabel: {
    id: 'Generic.contactSupportLabel',
    defaultMessage: 'Contact Support',
  },
  stoneAgeLogo: {
    id: 'Generic.stoneAgeLogo',
    defaultMessage: 'StoneAge Logo',
  },
  organizationControllersLabel: {
    id: 'Generic.organizationsControllerLabel',
    defaultMessage: 'Controllers',
  },
});
